
import Breadcrumbs from '~/components/UI/Breadcrumbs';
import BigNewsCard from '~/components/news/BigNewsCard';
import SmallNewsCard from '~/components/news/SmallNewsCard';
import CmsMetaMixin from '~/node_modules/sitis-nuxt/lib/mixins/CmsMetaMixin';

export default {
  name: 'NewsPage',
  data() {
    return {
      breadcrumbs: [
        { path: '/', title: 'Главная' },
        { path: '/news', title: 'Новости' },
      ],

      news: [],

      pagination: {
        page: 1,
        totalPage: 1,
      },

      isLoad: true,
    };
  },
  async fetch() {
    await this.loadMeta();
    await this.getArticles();
  },

  mixins: [CmsMetaMixin],

  computed: {
    isVisibleButtonNext: function () {
      return Boolean(this.pagination?.page < this.pagination?.totalPage);
    },
  },

  components: {
    Breadcrumbs,
    BigNewsCard,
    SmallNewsCard,
  },

  methods: {
    setCard(idx) {
      switch (idx) {
        case 0:
          return 'BigNewsCard';

        default:
          return 'SmallNewsCard';
      }
    },

    async getArticles(params = {}) {
      this.isLoad = true;

      const page = params?.newPage || this.$route.query?.page || this.pagination.page;
      const response = await this.$api.agent.transport.get(`/news?page=${page}&expand=tags`).then((res) => res).catch(() => ({}));

      const pagination = {
        page: Number.parseFloat(response?.headers?.['x-pagination-current-page'] || 1),
        totalPage: Number.parseFloat(response?.headers?.['x-pagination-page-count'] || 1),
      };
      const news = response?.data || [];
      this.setSearchParams(pagination.page);

      this.news = [...this.news, ...news];
      this.pagination = pagination;
      this.isLoad = false;
    },

    async changePage(newPage) {
      const pagination = { ...this.pagination };
      pagination.page = newPage;
      this.pagination = pagination;

      window.scrollTo({
        top: 0,
      });

      await this.getArticles({ newPage });
    },
    setSearchParams(page) {
      if (!process.client) {
        return;
      }

      const search = [`page=${page}`];

      window.history.replaceState(null, null, `${window.location?.pathname}?${search.join('&')}`);
    },

    moreNews: async function () {
      const pagination = { ...this.pagination };
      pagination.page += 1;
      this.pagination = pagination;
      await this.getArticles({
        newPage: pagination.page,
      });
    },
  },
};
